import { A as F, C as I, P as L, R as P, i as b, j as Z, e as j, f as O, b as Y, m as k, n as v, l as H, d as _, c as q, a as z, g as B, k as E, h as G } from "./product-utils-BZ9FKiCb.js";
function m(t, e) {
  const n = e ? 0 : 2, o = (t.getMonth() + 1).toString().padStart(2, "0"), r = t.getDate().toString().padStart(2, "0"), a = t.getFullYear().toString().slice(n, 4);
  return `${o}/${r}/${a}`;
}
function s(t = /* @__PURE__ */ new Date(), e = !1) {
  t = t instanceof Date ? t : new Date(t);
  const n = e ? "2-digit" : "numeric", o = t.toLocaleDateString("en-US", {
    month: n,
    year: "2-digit",
    day: n,
    timeZone: "UTC"
  }).split("/");
  return [o[0], o[1], o[2]].join("/");
}
function f(t = /* @__PURE__ */ new Date()) {
  return s(t, !0);
}
const l = (t = /* @__PURE__ */ new Date()) => (t = t instanceof Date ? t : new Date(t), t.toLocaleDateString("en-US", {
  month: "long",
  year: "numeric",
  day: "numeric",
  timeZone: "UTC"
})), h = (t = /* @__PURE__ */ new Date()) => {
  t = t instanceof Date ? t : new Date(t);
  const e = t.toLocaleDateString("en-US", {
    month: "2-digit",
    year: "numeric",
    day: "2-digit",
    timeZone: "UTC"
  }).split("/");
  return [e[2], e[0], e[1]].join("-");
}, T = (t = /* @__PURE__ */ new Date()) => (t = t instanceof Date ? t : new Date(t), new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate())), w = (t = /* @__PURE__ */ new Date()) => (t = t instanceof Date ? t : new Date(t), t.toLocaleDateString("en-US", {
  month: "2-digit",
  year: "numeric",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: !1,
  timeZone: "UTC"
}).replace(/(\/)|(:)|(\s)/g, "").replace(/,/g, "_"));
function C(t) {
  const [e, n, o] = t == null ? void 0 : t.split("-"), r = Number.parseInt(n, 10) - 1;
  return new Date(e, r, o);
}
const R = (t, e) => {
  const n = new Date(t);
  return n.setDate(n.getDate() + e), n;
}, u = (t, e) => {
  const n = new Date(t);
  e = e instanceof Date ? e : new Date(e);
  const o = [];
  for (; n <= e; )
    o.push(s(n)), n.setDate(n.getDate() + 1);
  return o;
}, S = (t, e) => new Map(
  u(t, e).map((n) => [n, { date: n }])
);
function g(t) {
  return t < 60 ? [0, t] : t && [(t / 60).toFixed(0), 0];
}
function D(t) {
  if (Number.isNaN(t) || !t)
    return;
  const [e, n] = g(t);
  return e > 60 ? [Math.floor(e / 60), e % 60, n] : [0, e, n];
}
function y(t, e = !0) {
  if (t === 0 || !t || !Number.isInteger(t))
    return t;
  const [n, o, r] = D(t), a = n ? `${n}hr` : "", i = o ? `${o}min` : "", c = r ? `${r}sec` : "";
  return `${a} ${i} ${e ? c : ""}`.trim();
}
function N(t, e) {
  const n = t * 100;
  return t && n.toFixed(e);
}
function U(t) {
  const e = t * 100;
  return t && Math.trunc(e);
}
function M(t, e) {
  const n = t % e === 0 ? t + e : t;
  return t > 0 ? Math.ceil(n / e) * e : e;
}
function x(t, e) {
  const n = t % e === 0 ? t + e : t;
  return t > 0 ? Math.floor(n / e) * e : e;
}
const $ = (t, e = 500) => {
  let n;
  return (o) => {
    clearTimeout(n), n = setTimeout(() => {
      t(o);
    }, e);
  };
};
export {
  F as AllRoles,
  I as Color,
  L as Product,
  P as Role,
  b as RoleTransformations,
  Z as RoleTransformationsMap,
  R as addDays,
  D as convertToHours,
  g as convertToMinutes,
  $ as debounce,
  m as formatDate,
  h as formatDateDashes,
  s as formatDateDigits,
  l as formatDateLocaleMonth,
  f as formatDateTwoDigits,
  y as formatTime,
  w as formatTimestap,
  j as getClientMultiOrgRoles,
  O as getClientSingleOrgRoles,
  C as getDateFromString,
  u as getDatesInRange,
  S as getDatesInRangeMap,
  M as getNearestMaxValue,
  x as getNearestMinValue,
  Y as getProduct,
  k as getProductName,
  v as getProducts,
  H as getRandomContrastColors,
  _ as getRole,
  q as getRoleAvatarColor,
  z as getRoleIconClassName,
  B as getRoleName,
  E as getRoleTransformations,
  T as getUTCDate,
  G as hasRole,
  N as roundToDecimals,
  U as truncateNumber
};
